import { render, staticRenderFns } from "./FlowArea.vue?vue&type=template&id=ddee8128"
import script from "./FlowArea.vue?vue&type=script&lang=js"
export * from "./FlowArea.vue?vue&type=script&lang=js"
import style0 from "./FlowArea.vue?vue&type=style&index=0&id=ddee8128&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddee8128')) {
      api.createRecord('ddee8128', component.options)
    } else {
      api.reload('ddee8128', component.options)
    }
    module.hot.accept("./FlowArea.vue?vue&type=template&id=ddee8128", function () {
      api.rerender('ddee8128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreatedFlow/modules/FlowArea.vue"
export default component.exports